import './index.scss';

import * as Lightgallery from '../assets-base/assets-src/js/Spinao/Lightgallery';
import * as NetteAjaxForm from '../assets-base/assets-src/js/Spinao/NetteAjaxForm';
import * as ReCaptcha from '../assets-base/assets-src/js/Spinao/GoogleReCaptcha';

document.addEventListener("DOMContentLoaded", function() {
    Lightgallery.applyTo('#js-lightgallery', {
        selector:'.js-lightgallery-image',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    NetteAjaxForm.initialize('[data-ajax="form"]');
    ReCaptcha.initialize();
});
